export const configuration  = {
  //environment: "Development",
  environment: "Production",
  version: "2.4.0",
  //baseUri: "https://immucertadmin-usw2-prod-app01-staging.azurewebsites.net"
  baseUri: "https://immucertadmin-usw2-prod-app01.azurewebsites.net"
  //baseUri: "https://localhost:44345"
}

export const msalConfig = {
  auth: {
    clientId: "35495585-f3cd-411e-b25b-80ba29559340",
    authority: "https://login.microsoftonline.com/9e80545a-f316-46ac-ae1f-82633bcf111e", // This is a URL (e.g. https://login.microsoftonline.com/{your tenant ID})
    redirectUri: configuration.baseUri + "/home",
  },
  cache: {
    cacheLocation: "sessionStorage", // This configures where your cache will be stored
    storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
  }
};

// Add scopes here for ID token to be used at Microsoft identity platform endpoints.
export const loginRequest = {
  scopes: ["User.Read"]
};

export const tokenRequest = {
  scopes: ["api://bbed8153-f2e5-4593-b9d4-09e8cc52031f/access_as_user"]
};


// Add the endpoints here for Microsoft Graph API services you'd like to use.
export const graphConfig = {
  graphMeEndpoint: "https://graph.microsoft.com/v1.0/me"
};
